// Static data + in-memory store for the IHG Custom Buyer Briefs demo.
// No backend: four seeded briefs with canned outputs, and any brief created
// through the wizard stays in a generating state forever (it never completes).

import { IhgBrief, IhgBriefStatus, IhgBriefType } from "./IhgDemoTypes";
import {
    AWS_BRIEF_HTML,
    ASPIRE_BRIEF_HTML,
    CREATOR_PLATFORMS_BRIEF_HTML,
    PWC_BRIEF_HTML,
} from "./ihgBriefContent";
import awsLogo from "./assets/aws-logo.png";
import aspireLogo from "./assets/aspire-logo.png";
import pwcLogo from "./assets/pwc-logo.png";

export const SEED_BRIEFS: IhgBrief[] = [
    {
        id: 1,
        briefType: IhgBriefType.CATEGORY_BENCHMARK,
        subject: "Influencer & Creator Platforms",
        category: "Commercial & Marketing",
        goalLabel: "Category Benchmark",
        status: IhgBriefStatus.COMPLETED,
        createdAt: "2026-07-22T12:00:00",
        briefHtml: CREATOR_PLATFORMS_BRIEF_HTML,
    },
    {
        id: 2,
        briefType: IhgBriefType.SUPPLIER,
        subject: "Amazon Web Services",
        category: "Cloud & Infrastructure",
        goalLabel: "Competitive Comparison",
        status: IhgBriefStatus.COMPLETED,
        recommendation: "Conditional",
        createdAt: "2026-07-20T12:00:00",
        logoUrl: awsLogo,
        briefHtml: AWS_BRIEF_HTML,
    },
    {
        id: 3,
        briefType: IhgBriefType.SUPPLIER,
        subject: "Aspire",
        category: "Influencer & Creator Platforms",
        goalLabel: "New Supplier Evaluation",
        status: IhgBriefStatus.COMPLETED,
        recommendation: "Conditional",
        createdAt: "2026-07-21T12:00:00",
        logoUrl: aspireLogo,
        briefHtml: ASPIRE_BRIEF_HTML,
    },
    {
        id: 4,
        briefType: IhgBriefType.SUPPLIER,
        subject: "PwC",
        category: "Management Consulting",
        goalLabel: "Contract Negotiation Prep",
        status: IhgBriefStatus.COMPLETED,
        recommendation: "Conditional",
        createdAt: "2026-07-21T12:00:00",
        logoUrl: pwcLogo,
        briefHtml: PWC_BRIEF_HTML,
    },
];

// ---- In-memory store (resets on page reload) ----

const store = {
    briefs: [...SEED_BRIEFS],
    nextId: 100,
};

export function getIhgBriefs(): IhgBrief[] {
    return store.briefs;
}

export function getIhgBrief(id: number): IhgBrief | undefined {
    return store.briefs.find((b) => b.id === id);
}

export interface IhgBriefInput {
    briefType: IhgBriefType;
    subject: string;
    category: string;
    goalLabel: string;
}

/**
 * Mock brief creation: the new brief appears at the top of the list as
 * Processing and stays there forever — generated briefs never complete.
 */
export function createIhgBrief(input: IhgBriefInput): IhgBrief {
    const brief: IhgBrief = {
        id: store.nextId++,
        briefType: input.briefType,
        subject: input.subject,
        category: input.category,
        goalLabel: input.goalLabel,
        status: IhgBriefStatus.PROCESSING,
        createdAt: new Date().toISOString(),
    };
    store.briefs = [brief, ...store.briefs];
    return brief;
}
